import React from "react";
import { useLanguage } from "../context/LanguageContext";
import { content } from "../data/content";
import { Globe } from "lucide-react";

const Navbar = () => {
  const { lang, toggleLang } = useLanguage();

  return (
    <nav className="w-full py-8">
      <div className="max-w-4xl mx-auto px-6 flex justify-end">
        <button
          onClick={toggleLang}
          className="flex items-center gap-2 text-sm font-medium text-muted-foreground hover:text-foreground transition-colors bg-secondary/30 px-3 py-1.5 rounded-full hover:bg-secondary/50"
        >
          <Globe className="w-4 h-4" />
          <span className="uppercase">{lang === 'en' ? 'cz' : 'en'}</span>
        </button>
      </div>
    </nav>
  );
};

export default Navbar;
